var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProfiledropdownBulkupload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload",
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_54369",
    "data-name": "Path 54369",
    d: "M18.182,13a.818.818,0,0,0-.818.818v3.447a2.283,2.283,0,0,1-2.28,2.28H4.917a2.283,2.283,0,0,1-2.28-2.28V13.818a.818.818,0,1,0-1.636,0v3.447a3.921,3.921,0,0,0,3.917,3.917H15.083A3.921,3.921,0,0,0,19,17.265V13.818A.818.818,0,0,0,18.182,13Z",
    transform: "translate(0 -2.182)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54370",
    "data-name": "Path 54370",
    d: "M6.4,7.306,9.909,3.793v10.3a.818.818,0,0,0,1.636,0V3.793l3.512,3.512a.818.818,0,1,0,1.157-1.157L11.306,1.24a.818.818,0,0,0-1.157,0L5.24,6.149A.818.818,0,1,0,6.4,7.306Z",
    transform: "translate(-0.727)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfiledropdownBulkupload);
export default __webpack_public_path__ + "static/media/profiledropdown-bulkupload.b7d3823cb1652ac093b3bfddce06bc27.svg";
export { ForwardRef as ReactComponent };